import { render, staticRenderFns } from "./process-info.vue?vue&type=template&id=3231448a&scoped=true&"
import script from "./process-info.vue?vue&type=script&lang=js&"
export * from "./process-info.vue?vue&type=script&lang=js&"
import style0 from "./process-info.vue?vue&type=style&index=0&id=3231448a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3231448a",
  null
  
)

export default component.exports